import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, Transition as _Transition } from "vue"

import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { StatusCode } from './constants/enums';
import Loader from './components/Loader.vue';
import PageNotFound from '@/views/404/PageNotFound.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const defaultLayout = 'default';
const route = useRoute();
const store = useStore();
const showLoader = computed(() => store.getters.showLoader as boolean);
const showErrorPage = ref(false);

const layout = computed(() => {
  if (showErrorPage.value) {
    return defaultLayout;
  }
  return route.meta.layout || defaultLayout;
});

const error = computed(() => store.getters.errorCode);

watch(error, (value) => {
  if (value === StatusCode.BADREQUEST || value === StatusCode.ISE) {
    showErrorPage.value = true;
  } else {
    showErrorPage.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(layout))
    ? (_openBlock(), _createBlock(_Transition, {
        key: 0,
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)), null, {
            default: _withCtx(() => [
              (showErrorPage.value)
                ? (_openBlock(), _createBlock(PageNotFound, { key: 0 }))
                : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
              (_unref(showLoader))
                ? (_openBlock(), _createBlock(Loader, { key: 2 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})